import { NgModule } from '@angular/core';
import { RouteService } from '../../routing/services/route.service';
import { LoginPage } from './login/login.page';
import { ForgotPasswordPage } from './forgot-password/forgot-password.page';
import { PasswordResetPage } from './password-reset/password-reset.page';
import { LogoutPage } from './logout/logout.page';
import { SupportModule } from '../../support/support.module';
import { LoginComponent } from '../components/login/login.component';
import { AuthPageWrapperComponent } from './partials/page-wrapper/page-wrapper.component';
import { ForgotPasswordComponent } from '../components/forgot-password/forgot-password.component';
import { PasswordResetComponent } from '../components/password-reset/password-reset.component';
import { FormsModule } from '../../forms/forms.module';
import { RoutingModuleContract } from '../../support/modules/interfaces/routing-module.interface';
import { RoutingModule as RouterModule } from '../../routing/routing.module';
import { RoutingModule } from '../../support/modules/routing-module';

@NgModule({
    imports: [
        RouterModule,
        SupportModule,
        FormsModule
    ],
    exports: [],
    declarations: [
        LoginPage,
        ForgotPasswordPage,
        PasswordResetPage,
        LogoutPage,
        LoginComponent,
        AuthPageWrapperComponent,
        ForgotPasswordComponent,
        PasswordResetComponent
    ],
    entryComponents: [
        LoginPage,
        ForgotPasswordPage,
        PasswordResetPage,
        LogoutPage
    ],
    providers: [],
})
export class AuthenticationRoutingModule extends RoutingModule implements RoutingModuleContract {

    public routes(routes: RouteService) {
        routes.add('login', LoginPage, 'login', { layout: 'blank-aside' });
        routes.add('auth/login', LoginPage, 'login', { layout: 'blank-aside' });
        routes.add('auth/forgot-password', ForgotPasswordPage, 'forgot-password', { layout: 'blank-aside' });
        routes.add('auth/password-reset', PasswordResetPage, 'password-reset', { layout: 'blank-aside' });
        routes.add('auth/password-reset/:token', PasswordResetPage, 'password-reset-token', { layout: 'blank-aside' });
        routes.add('logout', LogoutPage, 'logout', { layout: 'blank-aside' });
        routes.add('auth/logout', LogoutPage, 'logout', { layout: 'blank-aside' });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/pages/authentication-routing.module.ts